import Choices from "choices.js";
<template>
  <div class="all-wrapper with-side-panel solid-bg-all" :class="(cpanel) ? 'content-panel-active' : ''" v-if="pageLoad >= 5">
    <AuthLogin v-if="!isLogged"/>
    <div class="layout-w" v-if="isLogged">

      <template v-if="w <= 1200">
        <Slideout menu="#menu" panel="#panelx" :toggleSelectors="['.menu-toggle-button','.docka']" >
          <nav id="menu">
            <Navigation/>
          </nav>
          <main id="panelx">
            <header>
              <div class="content-w">
                <div class="top-bar color-scheme-transparent">

                  <dockTopMenu />
                </div>

                <router-view></router-view>
              </div>
            </header>
          </main>
        </Slideout>
      </template>

      <template v-if="w > 1200">
        <Navigation/>
        <div class="content-w">
          <div class="top-bar color-scheme-transparent">
            <dockTopMenu />
          </div>

          <router-view></router-view>
        </div>
      </template>
    </div>

    <div class="display-type"></div>
	  <notifications group="foo" />
  </div>
</template>

<script>

  import Navigation from './Navigation'
  import AuthLogin from '@/components/auth/Login'
  import dockTopMenu from './dockTopMenu'
  import VueSticky from 'vue-sticky'
  import Slideout from 'vue-slideout'

export default {
  components: { Navigation, AuthLogin, dockTopMenu, Slideout },
  directives: {
      'sticky': VueSticky,
  },
    name: 'app',
    data () {
        return {
            w: window.innerWidth,
            app : false,
            blurred: true,
            ready: false,
            pageLoad: 0,
            session: [],
            isLogged: false,
            t: false,
            accessToken: null,
            refreshToken: null,
            clientId: null,
            clientSecret: null,
            loading: true,
            clientId: null,
            clientSecret: null,
            darkMode: false,
            modalTheme: 'light',
            cpanel: false
        }
    },
    watch: {
        'app' () {
            this.getClient();
            this.init();
        },
        accessToken () {
            this.getUserSession();
            //this.getWs();
        },
        'isLogged' () {
            this.init();
        },

    },
    mounted () {

        this.getTranslations();

        if (this.getApp()) {
            this.getTranslations();
            this.init();
            this.$root.loading = false;
            this.loading = false;
        }

        this.$bus.$on('openPanel', (payload) => {
            this.cpanel = payload;
        });

        this.$bus.$on('sessionUpdated', (payload) => {

            this.getUserSession();
        //this.getWs();
        });

        this.$bus.$on('globalLoader', (payload) => {
            this.loading = payload;
        });

        this.$bus.$on('darkMode', (payload) => {

            this.$setItem('darkMode', payload);

            this.darkMode = payload;

            this.changeSchemeColor();
        });

        setInterval(this.getUserSession, 60000);
        setInterval(this.refreshTokenRoll, 3600000);

        this.$nextTick(function () {
            setTimeout(this.changeSchemeColor, 2000);
        })
    },
    methods: {
        scrollFix () {
            var modal = document.querySelector(".sweet-modal-overlay");

            if (modal) {
                modal.addEventListener("mouseover", (event) => {
                    setTimeout(() => {
                    document.body.style.overflow='hidden';
                }, 500);
            });

                modal.addEventListener("mouseleave", (event) => {
                    setTimeout(() => {
                    document.body.style.overflow='auto';
                  }, 500);
                });
            }else {
                setTimeout(() => {
                    document.body.style.overflow='auto';
                }, 500);
            }
        },
        init () {
            this.getWs();

            this.pageLoad += 1;

            var th = this;
            setInterval(function(){
                th.scrollFix()
            }, 1000);


        },
        changeSchemeColor (scheme) {

            var self = this;


            this.$getItem('darkMode', function (key, value) {
                //console.log all the kay/value pairs
                self.darkMode = value;

                self.$root.darkMode = value;

                self.$root.modalTheme = (value) ? 'dark' : 'light'

            }, function (err) {

            })

            var mw = document.getElementById("menu-w");

            if (mw) {
                mw.classList.add("color-scheme-light");
                mw.classList.add("sub-menu-color-light");
                mw.classList.add("selected-menu-color-light");
            }


            if (self.darkMode) {

                document.body.classList.add("color-scheme-dark");

                if (mw) {
                    document.getElementById("menu-w").classList.remove("color-scheme-light");
                    document.getElementById("menu-w").classList.remove("sub-menu-color-light");
                    document.getElementById("menu-w").classList.remove("selected-menu-color-light");

                    //self.$setItem('darkMode', true);
                    document.getElementById("menu-w").classList.add("color-scheme-dark");
                    document.getElementById("menu-w").classList.add("sub-menu-color-dark");
                    document.getElementById("menu-w").classList.add("selected-menu-color-bright");
                }

            }else {
                //self.$setItem('darkMode', false);

                document.body.classList.remove("color-scheme-dark");

                if (mw) {
                    document.getElementById("menu-w").classList.remove("color-scheme-dark");
                    document.getElementById("menu-w").classList.remove("sub-menu-color-dark");
                    document.getElementById("menu-w").classList.remove("selected-menu-color-bright");
                }

            }

            this.pageLoad += 1;

        },
        getWs() {

            window.__lc = window.__lc || {};
            window.__lc.license = 10178987;
            (function() {
                var lc = document.createElement('script'); lc.type = 'text/javascript'; lc.async = true;
                lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';
                var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(lc, s);
            })();

            window.webs = WS.connect(window.wsapi+'?accessToken='+this.$root.accessToken);

            var th = this;
            webs.on("socket/connect", function(s){
                window.wss = s;

                setInterval(function(){
                    s.subscribe("channel/ping_pong", function(uri, payload){

                    });
                    s.publish("channel/ping_pong", 1);
                    s.unsubscribe("channel/ping_pong");
                }, 50000);
            });

            webs.on("socket/disconnect", function(error){
                //error provides us with some insight into the disconnection: error.reason and error.code

                console.log("Disconnected for " + error.reason + " with code " + error.code);
            });

            this.pageLoad += 1;
        },
        getTokens (){
            var th = this;
            this.$getItem('auth', function (key, value) {
                //console.log all the kay/value pairs

                return value;

            }, function (err) {

                return false;
            })
        },
        getUserSession (u) {
        var tokens = this.getTokens();

        var self = this;
        this.$getItem('session', function (key, value) {
            //console.log all the kay/value pairs

            if (!value){
                self.updateBets([]);
            }

            self.session = value;
            self.$root.session = value;
            window.session = value;

            self.loading = false;

        }, function (err) {

            self.loading = false;
        })


        var th = this;
        this.$getItem('auth', function (key, a) {
            //console.log all the kay/value pairs
            th.$bus.$emit('globalLoader', false);

            if(!a){
                    window.auth.accessToken = null;
                    window.auth.client = null;
            }else{
                window.auth = a;
            }

            th.$http.get(api+'api/get/session', ).then(response => {

                th.isLogged = true
                // get body data
                th.session = response.body.result;
                th.$root.session = response.body.result.user;
               // th.meta = response.body.result.app.meta;
                window.session = response.body.result.user;

                console.log(window.session)

                th.$setItem('session',  response.body.result.user);

                window.document.title = th.meta.title;

                self.loading = false;

                if (session.timezone) {
                    window.moment.tz.load({
                        zones : [],
                        links : [session.timezone],
                    });
                }

                if (window.session) {
                    th.pageLoad += 1;
                }

                th.$bus.$emit('Session', response.body.result.user);

                th.isLogged = true;

          }, response => {

                if ((response.status == 404 || response.status == 401) && th.app) {
                    th.$bus.$emit('globalLoader', false);
                    self.loading = false;
                    th.$setItem('auth', {});
                    th.isLogged = false
                }

              });

        }, function (err) {

            return false;
        })
        },
        refreshTokenA () {

            if (this.refreshToken && this.clientId && this.clientSecret) {
                this.$http.get(api+'oauth/v2/token',
                    {params:  {client_id: this.clientId, client_secret: this.clientSecret,grant_type: 'refresh_token',
                        refresh_token: this.refreshToken } }).then(
                    response => {
                        this.accessToken = response.body.access_token;
                        this.refreshToken = response.body.refresh_token;

                        this.$cookie.set('access_token', response.body.access_token, 1);
                        this.$cookie.set('refresh_token', response.body.refresh_token, 1);
                        window.accessTokenHeader = response.body.access_token;

                    }, response => {

                    });

            }else {
                this.blurred = false;
            }
        },
        getCanonicalHost(hostname) {
            const MAX_TLD_LENGTH = 3;
            
            function isNotTLD(_) { return _.length > MAX_TLD_LENGTH; };
            hostname = hostname.split('.');
            hostname = hostname.slice(Math.max(0, hostname.findLastIndex(isNotTLD)));
            hostname = hostname.join('.');

            return hostname;
        },
        getApp () {

        var hostname = this.getCanonicalHost(window.location.hostname);

        if (hostname == 'localhost') {
            hostname = 'eu.plysport.com';
        }

        this.$http.get(bsapi+'api/getAppByHostname/'+hostname).then(response => {
            var app = response.body.app;
            var socketProtocol = (window.location.protocol === 'https:') ? 'wss://' : 'ws://';

            if (app && bsapi == 'https://eu.plysport.com/') {
                window.api = 'https://eu.plysport.com/';
                window.wsapi = socketProtocol + app.hostname;
            }else if (app && hostname === 'bs.co') {
                window.api = location.protocol +'//'+ app.hostname + '/';
                window.wsapi = socketProtocol + app.hostname;
            }else {
                //hostname = 'bs.co';
                window.api = location.protocol +'//'+ hostname + '/';
                window.wsapi = socketProtocol + hostname;
            }

            this.$root.app = app;
            this.app = app;

        }, response => {
            // error callback
        });

        },
        refreshTokenRoll () {

            var th = this;
            this.$getItem('auth', function (key, value) {
                //console.log all the kay/value pairs

                if(value.hasOwnProperty( 'refreshToken' )){
                    th.$http.get(api+'oauth/v2/token',
                        {params:  {client_id: value.client, client_secret: value.clientSecret,grant_type: 'refresh_token',
                                refresh_token: value.refreshToken } }).then(
                        response => {

                            window.accessTokenHeader = response.body.access_token;
                            window.auth.accessToken = response.body.access_token;
                            window.auth.refreshToken = response.body.refresh_token;

                            th.$setItem('auth', window.auth);

                        }, response => {
                            window.auth = null;
                            windows.session = null;
                            th.$router.push( '/' );
                        });
                }

            }, function (err) {

            })
        },
        getClient () {

            this.accessToken = window.auth.accessToken;

            /*

            if (!this.accessToken) {
                this.$http.get(api+'api/v1/get/client').then(response => {
                    // get body data
                    this.clientId = response.body.client_id;
                    this.clientSecret = response.body.client_secret;

                window.auth.client = response.body.client_id;
                window.auth.clientSecret = response.body.client_secret;

                this.$setItem('auth', window.auth);

            }, response => {
                    // error callback
                    //this.$cookie.delete('client_id');
                    //this.$cookie.delete('client_secret');
                });
            } */
        },
        getTranslations () {

            if (this.loading ) {
                this.$http.get(bsapi+'api/v1/info_translations/get/all',
                ).then(response => {
                    // get body data
                    this.tinfo = response.body.result.translation;
                    this.$root.tinfo = this.tinfo;


                }, response => {
                    // error callback
                })

                this.$http.get(bsapi+'api/v1/translations/get/all',
                ).then(response => {
                    // get body data
                    this.t = response.body.result.translation;
                    this.$root.t = this.t;

                    window.moment.locale('tr');
                    var NowMoment = moment().format("dddd, MMMM Do");

                    this.loading = false;

                    this.init();

                }, response => {
                    // error callback
                    this.loading = false;
                })
            }

        },
        sessionStop () {
            this.$cookie.delete('client_id');
            this.$cookie.delete('client_secret');
            window.location.reload();
        },
        openForgot () {
            this.$refs.fpmodal.open();
        },

    }

}
</script>

<style>
  .content-box {
    vertical-align: top;
  }

  .slideout-menu {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 256px;
    height: 100vh;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    z-index: 0;
    display: none;
    border-right: 1px solid rgba(255, 255, 255, 0.05);
  }

  .slideout-menu-left {
    left: 0;
  }

  .slideout-menu-right {
    right: 0;
  }

  .slideout-panel {
    position: relative;
    z-index: 1;
    /* will-change: transform; */
    min-height: 100vh;
  }

  .slideout-open,
  .slideout-open body,
  .slideout-open .slideout-panel {
    overflow: hidden;
  }

  .slideout-open .slideout-menu {
    display: block;
  }
  .menu-toggle-button{
    font-size: 24px;
    background: none;
    border: none;
    position: absolute;
    left: 10px;
  }
  #menu-w {
    min-height: 100vh;
  }

  @media screen and (max-width: 1150px) {
    .content-w {
      min-width: 100vw;
    }
  }

  .menu-w.color-scheme-dark {
    background: url(/static/assets/img/blur-bg.jpg) !important;
  }
</style>





// WEBPACK FOOTER //
// src/App.vue